import {
    Parser,
} from 'hot-formula-parser';
import moment from 'moment';

import {roundNumber} from '@/helpers/dataHelper';
import {getPrecisionFormat} from '@/helpers/dateTimeHelper';
import geoNames from '../../data/namesAliases/geoNames.json';
import devicesNames from '../../data/namesAliases/devicesNames.json';
const converter = require('number-to-words');

export const fractionalEventsWithOriginalNames = ['expense', 'revenue', 'job_expense', 'taxfree', 'backend_expense', 'proceeds'];

export const namesChangesForFormulas = {};

export const longNameEventsShortcuts = {
    trial_converted: 't2a',
    intro_started: 'ist',
    intro_converted: 'i2a',
    intro24h: 'i24h',
    intro48h: 'i48h',
    job_expense: 'jbx',
    backend_expense: 'bcx',
    taxfree: 'txf',
    trial1h: 't1h',
    trial2h: 't2h',
    trial24h: 't24h',
    trial48h: 't48h',
    refund_declined: 'rfd',
};

export const getConfidenceColor = function (confidence) {
    if (confidence < 5) {
        return 'red';
    } else if (confidence < 8) {
        return 'orange';
    } else if (confidence <= 10) {
        return 'green';
    }
    return 'green';
};

export const replaceFullName = function (name) {
    if (namesChangesForFormulas[name]) {
        return namesChangesForFormulas[name];
    }
    return name;
};

export const setRevenueNames = function (allEvents) {
    _.cloneDeep(allEvents).map(event => {
        if (event.name.startsWith("revenue") && event.name.length > 7) {
            const number = event.name.match(/\d+/)[0];
            const nameFormatted = converter.toWords(number).replace(/[\s-_]/g, '');
            namesChangesForFormulas[event.name] = 'rev' + nameFormatted;
            longNameEventsShortcuts[event.name] = 'rev' + number;
            fractionalEventsWithOriginalNames.push(event.name);
        }
    });
};

export const replacePartFormulaName = function (name, isAdditional, parserAdditional, namesChangesForFormulas = {}, replaceDigitsWithSymbolsInner) {
    let replacedName = name;
    if (isAdditional && parserAdditional) {
        Object.keys(parserAdditional).forEach((name) => {
            replacedName = replacedName.replace(name, replaceDigitsWithSymbolsInner(name));
        });
    } else {
        Object.entries(namesChangesForFormulas).forEach(([oldName, newName]) => {
            replacedName = replacedName.replace(oldName, newName);
        });
    }
    return replacedName;
};

export const getIndexesByNames = function (array, names) {
    const indexes = [];
    array.forEach((element, elementIndex) => {
        if (names.includes(element.name)) {
            indexes.push(elementIndex);
        }
    });
    return indexes;
};

export const fillItemsChangesArray = function (array) {
    const itemsChanges = {};
    for (let i = 0; i < array.length; ++i) {
        itemsChanges[array[i].uniqueId] = {};
    }
    return itemsChanges;
};
export const replaceDigitsWithSymbols = function (input) {
    const symbols = ['X', 'T', 'M', 'N', 'A', 'S', 'O', 'P', 'V', 'G'];
    return input.replace(/\d/g, match => symbols[parseInt(match, 10)]);
};
export const replaceDigitsWithSymbolsStartsWithLetters = function (input) {
    const symbols = ['X', 'T', 'M', 'N', 'A', 'S', 'O', 'P', 'V', 'G'];
    return input.replace(/([a-zA-Z])(\d+)/g, (match, letter, digits) => {
        return letter + digits.split('').map(digit => symbols[parseInt(digit, 10)]).join('');
    });
};

export function mapFeatureData(...args) {
    const mappingData = window.JSONfn.stringify({
        fractionalEventsWithOriginalNames,
        namesChangesForFormulas,
        replaceFullName,
        replacePartFormulaName,
        replaceDigitsWithSymbols,
        replaceDigitsWithSymbolsStartsWithLetters,
        generateAdditionalColumnsVariables,
        getIndexesByNames,
        fillItemsChangesArray,
        geoNames,
        devicesNames,
    });
    return this.$worker.run(mapFeatureDataWorker, [mappingData, ...args]);
}

export function mapFeatureDataWorker(mappingDataString, domain, featuresFromResponse, currentTabFeatures, currentTabEvents, allFormulas, featuresOrder, featuresSettings, featuresSettingsLocal, additionalColumns,arppuCoef) {

    importScripts(`${domain}/js/formula-parser.js`);// eslint-disable-line
    importScripts(`${domain}/js/JSONfn.js`);// eslint-disable-line
    const mappingData = JSONfn.parse(mappingDataString); // eslint-disable-line
    const fractionalEvents = mappingData.fractionalEventsWithOriginalNames;
    const replacePartFormulaName = mappingData.replacePartFormulaName;
    const replaceDigitsWithSymbols = mappingData.replaceDigitsWithSymbols;
    const replaceDigitsWithSymbolsStartsWithLetters = mappingData.replaceDigitsWithSymbolsStartsWithLetters;
    const generateAdditionalColumnsVariables = mappingData.generateAdditionalColumnsVariables;
    const geoNames = mappingData.geoNames;
    const devicesNames = mappingData.devicesNames;

    const getNameAliases = function (featureName) {
        if (featureName === 'geo') {
            return geoNames;
        } else if (featureName === 'device') {
            return devicesNames;
        }
        return null;
    };

    function titleCase(string) {
        return string[0].toUpperCase() + string.slice(1);
    }

    const parserAdditional = generateAdditionalColumnsVariables(additionalColumns);
    const fractionalEventsIndexes = [];
    currentTabEvents.forEach((event, eventIndex) => {
        if (fractionalEvents.includes(event.name)) {
            fractionalEventsIndexes.push(eventIndex);
        }
    });

    const eventsWithFormulas = currentTabEvents.concat(allFormulas);

    let features = featuresFromResponse.map((featureData, featureIndex) => {
        const feature = JSON.parse(JSON.stringify(currentTabFeatures[featureIndex]));
        const currentFutureSettings = Object.assign(featuresSettings[feature.name] || {}, featuresSettingsLocal[feature.name] || {});
        let deletedIndexes = [];
        if (currentFutureSettings?.deletedEventsNames) {
            deletedIndexes = mappingData.getIndexesByNames(eventsWithFormulas, currentFutureSettings?.deletedEventsNames);
        }
        if (currentFutureSettings?.deletedFormulasNames) {
            deletedIndexes = deletedIndexes.concat(mappingData.getIndexesByNames(eventsWithFormulas, currentFutureSettings?.deletedFormulasNames));
        }

        const allColorsFromRows = [];
        feature.rows = Object.freeze(featureData.map((row, rowIndex) => {
            const newRow = {};
            newRow.color = row.color;
            if (row.color) {
                allColorsFromRows.push(row.color);
            }
            newRow.value = row.value;
            if (getNameAliases(feature.name) && getNameAliases(feature.name)[row.value.toLowerCase()]) {
                const fullName = titleCase(getNameAliases(feature.name)[row.value.toLowerCase()].toString());
                newRow.showName = `${row.value} (${fullName})`;
            } else {
                newRow.showName = row.value;
            }
            newRow.uniqueId = rowIndex;
            const formulas = [];
            let events = row.counts;
            fractionalEventsIndexes.forEach((index) => {
                if (row.counts[index]) {
                    events[index] = row.counts[index].toFixed(2);
                }
            });

            const parser = new formulaParser.Parser(); // eslint-disable-line
            parser.setVariable('coef', arppuCoef? 0.85 : 0.7);
            currentTabEvents.forEach((event, eventIndex) => {
                parser.setVariable(replaceDigitsWithSymbols(event.name), +row.counts[eventIndex]);
            });
            allFormulas.forEach((formula, formulaIndex) => {
                if (formula.isAdditionalColumn) {
                    Object.keys(parserAdditional).forEach((formulaName) => {
                        const value = parserAdditional[formulaName];
                        parser.setVariable(replaceDigitsWithSymbols(formulaName), +value);
                    });
                }
                const res = parser.parse(replacePartFormulaName(replaceDigitsWithSymbolsStartsWithLetters(formula.equation), formula.isAdditionalColumn, {}, replaceDigitsWithSymbols));
                // const res = parser.parse(formula.equation);
                formulas[formulaIndex] = res.result && isFinite(res.result) ? (Math.round(res.result * 100) / 100) : '';
            });
            newRow.cells = Object.freeze([].concat(events).concat(formulas));
            newRow.areSubrowsOpen = false;
            newRow.areSubrowsLoaded = false;
            newRow.areSubrowsLoading = false;
            newRow.subrows = [];
            return newRow;
        }));

        feature.itemsChanges = mappingData.fillItemsChangesArray(feature.rows);
        feature.colors = Object.freeze(Array.from(new Set(allColorsFromRows)));
        feature.events = Object.freeze(currentTabEvents);
        feature.deletedIndexes = deletedIndexes;
        feature.formulas = Object.freeze(allFormulas);
        feature.selectedIds = [];
        feature.selectedColors = [];
        feature.sumRows = [];
        feature.styles = {
            columnVisibilityStyles: '', columnsWidthStyles: '',
        };

        feature.filterValue = currentFutureSettings.filterValue ? currentFutureSettings.filterValue : {
            name: '', index: '', sort: '',
        };
        return feature;
    });
    features.push({
        name: 'Summary',
        colors: [],
        rows: [],
        itemsChanges: [],
        selectedIds: [],
        selectedColors: [],
        filters: [],
        events: [],
        deletedIndexes: [],
        formulas: [],
        sumRows: [],
    });
    let orderedFeatures = [];
    if (featuresOrder) {
        featuresOrder.forEach(function (key) {
            var found = false;
            features = features.filter(function (item, itemIndex) {
                if (!found && features[itemIndex].name === key) {
                    orderedFeatures.push(item);
                    found = true;
                    return false;
                } else return true;
            });
        });
        orderedFeatures = orderedFeatures.concat(features);
        return orderedFeatures;
    }
    return features;
}

export function getFormulaResult(formula, parserAdditional, additionalColumnsByFeature, shortFeatureName, events, row, arppuCoef) {
    const parser = new Parser();
    events.forEach((event, eventIndex) => {
        parser.setVariable(replaceDigitsWithSymbols(event.name), row.cells[eventIndex]);
    });
    parser.setVariable('coef', arppuCoef? 0.85 : 0.7);
    if (formula.isAdditionalColumn) {
        Object.entries(parserAdditional).forEach(([formulaName, value]) => {
            parser.setVariable(replaceDigitsWithSymbols(formulaName), +value);
        });
    }
    if (formula.isCurrentFeatureAdditionalColumn) {
        formula.currentFeatures.forEach((featureName) => {
            if (featureName === shortFeatureName) {
                additionalColumnsByFeature.forEach((column) => {
                    parser.setVariable(replaceDigitsWithSymbols(column.name), column.data[row.value]);
                });

            }
        });
    }
    const res = parser.parse(replacePartFormulaName(replaceDigitsWithSymbolsStartsWithLetters(formula.equation), formula.isAdditionalColumn, parserAdditional, namesChangesForFormulas, replaceDigitsWithSymbols));
    return res.result && isFinite(res.result) ? roundNumber(res.result) : '';
}

export function addFormulaToFeatures(features, featuresData, currentTabEvents, newFormula, formulaIndex, additionalColumns, arppuCoef) {
    const parserAdditional = generateAdditionalColumnsVariables(additionalColumns);
    featuresData.forEach((feature) => {
        const shortFeatureName = feature.name.split(' ')[0].toLowerCase();
        const additionalColumnsByFeature = additionalColumns[shortFeatureName];
        feature.rows.forEach((row) => {
            row.cells.splice(formulaIndex, 0, getFormulaResult(newFormula, parserAdditional, additionalColumnsByFeature, shortFeatureName, feature.events, row, arppuCoef));
        });
        feature.sumRows.forEach((row) => {
            row.cells.splice(formulaIndex, 0, getFormulaResult(newFormula, parserAdditional, additionalColumnsByFeature, shortFeatureName, feature.events, row, arppuCoef));
        });
    });
    return featuresData;
}

export function generateAdditionalColumnsVariables(additionalColumns) {
    const parserAdditional = {};
    Object.keys(additionalColumns).forEach((featureName) => {
        const columns = additionalColumns[featureName];
        columns.forEach(column => {
            Object.keys(column.data).forEach((propertyName) => {
                const value = column.data[propertyName];
                parserAdditional[`${featureName}${propertyName}`] = +value;
            });
        });
    });
    return parserAdditional;
}

export function updateFeatureFormulaColumn(featuresData, rowColumnIndex, newFormula, additionalColumns, arppuCoef) {
    const parserAdditional = generateAdditionalColumnsVariables(additionalColumns);
    featuresData.forEach((feature) => {
        const shortFeatureName = feature.name.split(' ')[0].toLowerCase();
        const additionalColumnsByFeature = additionalColumns[shortFeatureName];
        feature.rows.forEach((row) => {
            row.cells[rowColumnIndex] = getFormulaResult(newFormula, parserAdditional, additionalColumnsByFeature, shortFeatureName, feature.events, row,arppuCoef);
        });
    });
}

export function deleteFeatureFormulaColumn(features, featuresData, rowColumnIndex) {
    featuresData.forEach((data) => {
        data.rows.forEach((row) => {
            row.cells.splice(rowColumnIndex, 1);
        });
    });
    return featuresData;
}

export function mapSummaryTable(eventsFromResponse, events, allFormulas, precision, featuresSettings, featuresSettingsLocal, additionalColumns, arppuCoef) {
    const parserAdditional = generateAdditionalColumnsVariables(additionalColumns);
    const additionalColumnsByFeature = additionalColumns['summary'];
    const eventsNames = events.map((e) => replaceFullName(e.name));
    const fractionalEventsNames = fractionalEventsWithOriginalNames.map((eName) => replaceFullName(eName));
    const rows = [];
    const rowNameFormat = getPrecisionFormat(precision);
    const rowNames = Object.values(eventsFromResponse)[0].map((row) => moment(row.Date).format(rowNameFormat));
    const dayCount = rowNames.length;
    const eventsWithFormulas = events.concat(allFormulas);

    const currentFutureSettings = Object.assign(featuresSettings['Summary'] || {}, featuresSettingsLocal['Summary'] || {});

    let deletedIndexes = [];
    if (currentFutureSettings?.deletedEventsNames) {
        deletedIndexes = getIndexesByNames(eventsWithFormulas, currentFutureSettings?.deletedEventsNames);
    }
    if (currentFutureSettings?.deletedFormulasNames) {
        deletedIndexes = deletedIndexes.concat(getIndexesByNames(eventsWithFormulas, currentFutureSettings?.deletedFormulasNames));
    }

    for (let i = 0; i < dayCount; i++) {
        const namePrefix = precision === 'day' ? moment(rowNames[i]).format('dd') : 0;
        const row = {
            uniqueId: i, cells: [], value: rowNames[i], namePrefix, showName: rowNames[i],
        };
        const parser = new Parser();
        eventsNames.forEach((event, eventIndex) => {
            let value = '';
            if (eventsFromResponse[eventIndex][i].Count != null) {
                if (fractionalEventsNames.includes(event)) {
                    value = roundNumber(eventsFromResponse[eventIndex][i].Count);
                } else {
                    value = eventsFromResponse[eventIndex][i].Count;
                }
            }
            row.cells.push(value);
            parser.setVariable(event, value);
        });
        allFormulas.forEach((formula) => {
            row.cells.push(getFormulaResult(formula, parserAdditional, additionalColumnsByFeature, 'summary', events, row,arppuCoef));
        });
        row.areSubrowsOpen = false;
        row.areSubrowsLoaded = false;
        row.areSubrowsLoading = false;
        row.subrows = [];
        rows.push(row);

    }
    return {
        name: 'Summary',
        colors: [],
        rows: Object.freeze(rows),
        itemsChanges: fillItemsChangesArray(rows),
        selectedIds: [],
        sumRows: [],
        selectedColors: [],
        events: Object.freeze(events),
        deletedIndexes: deletedIndexes,
        filters: [],
        formulas: Object.freeze(allFormulas),
        styles: {
            columnVisibilityStyles: '', columnsWidthStyles: '', selectedRowsStyles: '',
        },
        filterValue: currentFutureSettings.filterValue ? currentFutureSettings.filterValue : {
            name: '', index: '', sort: '',
        },
    };
}

export function swapFeaturesColumns(features, firstIndex, secondIndex, deleteIndex) {
    features.forEach((feature) => {
        feature.rows.forEach((row) => {
            row.cells.splice(secondIndex, 0, row.cells[firstIndex]);
            row.cells.splice(deleteIndex, 1);
        });
        feature.sumRows.forEach((row) => {
            row.cells.splice(secondIndex, 0, row.cells[firstIndex]);
            row.cells.splice(deleteIndex, 1);
        });
    });
    return features;
}

// export function getHiddenFiltersForRequest(currentSourceFilter) {
//     const filter = {};
//     let equalString = '';
//     let excludeString = '';
//
//     if (currentSourceFilter.equal) {
//         Object.entries(currentSourceFilter.equal).forEach(([feature, filters]) => {
//             equalString += `&equal:${feature}=${filters.map((v) => encodeURIComponent(v)).join(',')}`;
//         });
//     }
//     if (currentSourceFilter.exclude) {
//         Object.entries(currentSourceFilter.exclude).forEach(([feature, filters]) => {
//             excludeString += `&exclude:${feature}=${filters.map((v) => encodeURIComponent(v)).join(',')}`;
//         });
//     }
//
//     filter.equal = equalString;
//     filter.exclude = excludeString;
//
//     return filter;
// }
